export const SENDER_OUTLOOK = 'outlook';
export const INTRODUCTION_TEMPLATE = 2;
export const MAX_NUMBER_OF_ATTACHMENTS = 15;
export const MAX_BODY_SIZE = 5770240;
export const BREAKPOINT_960 = '(min-width: 960px)';
export const BREAKPOINT_1280 = '(min-width: 1280px)';
export const BREAKPOINT_1450 = '(min-width: 1450px)';
export const BREAKPOINT_1650 = '(min-width: 1650px)';
